import root from 'window-or-global';
import useSWR from 'swr';
import {ErrorReportRes, errorFetcher, createAppKey} from './error.fetch';


export const useErrorReport = (errorToReport: string, errorInfo: React.ErrorInfo): {
    res?: ErrorReportRes;
    isLoading: boolean;
    error?: string;
} => {
    const {data, error} = useSWR(!root.__server_side_render && errorToReport && errorInfo ? createAppKey({errorToReport, errorInfo}) : null, errorFetcher.sendReportStr, {
        errorRetryCount: 1
    });

    return {
        res: data,
        isLoading: !data && !error,
        error
    };
};


export const useError404 = (path: string): {
    res?: ErrorReportRes;
    isLoading: boolean;
    error?: string;
} => {
    const {data, error} = useSWR(!root.__server_side_render && path ? path : null, errorFetcher.send404, {
        errorRetryCount: 1
    });

    return {
        res: data,
        isLoading: !data && !error,
        error
    };
};
